import * as _Sentry from 'sentry-expo';

export const Sentry = _Sentry.Browser;
